<script lang="ts">
  let { text = "OR" } = $props()
</script>

<div class="crtw-relative crtw-flex crtw-py-2 crtw-px-4 crtw-items-center">
  <div class="crtw-flex-grow crtw-border-t crtw-border-gray-400"></div>
  <span class="crtw-flex-shrink crtw-mx-4 crtw-text-gray-400">{text}</span>
  <div class="crtw-flex-grow crtw-border-t crtw-border-gray-400"></div>
</div>
